import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Button from '../../components/controls/Button';
import From from '../../components/controls/Form';
import FormGroup from '../../components/controls/Form/components/FormGroup';
import InputField from '../../components/controls/Form/components/InputField';
import Heading from '../../components/controls/Typography/Heading';
import { TextParagraph } from '../../components/controls/Typography/TextBody';
import BaseModal from '../../components/modals/BaseModal';
import { DEV_MODE } from '../../utils/Constants';
import useAuthUtils from '../../utils/useAuthUtils';

import './AccountLockout.less';

const AccountLockout = () => {
  const navigate = useNavigate();
  const auth = useAuthUtils();
  const [isBusy, setIsBusy] = useState(false);
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [openAccountLockoutSuccessModal, setOpenAccountLockoutSuccessModal] = useState(false);

  const handleEmailSubmit = async () => {
    setIsBusy(true);
    try {
      setErrorMessage(null);
      await auth.resetPasswordByEmail(email);
      setOpenAccountLockoutSuccessModal(true);
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setIsBusy(false);
    }
  };

  const toggleModal = () => {
    navigate('/login');
  };

  useEffect(() => {
    document.title = 'Letters Portal - Account Locked';
    DEV_MODE || auth.attributes.accountLocked ? void 0 : navigate('/login');
    auth.setAttributes({ accountLocked: false });
  }, []);

  return (<>
    <main className="lsn-page lsn-page-accountLockout container">
      <Heading
        className="no-focus-outline text-center"
        tabIndex={0}
        aria-label={`Letters portal by Liaison Account Locked`}
      >
        Account Locked
      </Heading>

      <From
        icon={<i className="far fa-lock"></i>}
        isMedium
        hasBorder
        isButtonsStack
        onSubmit={handleEmailSubmit}
        formAttr={{
          title: 'Account Locked'
        }}
        buttons={<>
          <Button
            primary
            isBusy={isBusy}
            submit
          >
            Reset
          </Button>

          <Button
            ghost
            primary
            onClick={() => {
              navigate('/login');
            }}
            type='button'
          >
            Cancel and Return to Sign In
          </Button>
        </>}
      >
        <TextParagraph className='text-center'>
          You've exceeded the maximum number of failed sign-in attempts.
        </TextParagraph>
        <TextParagraph className='text-center'>
          Enter your account's email to receive instructions on how to reset your password.
        </TextParagraph>

        <FormGroup
          required
          controlRender={(params) => <InputField
            inputType='email'
            name='email'
            autoComplete='email'
            title='Email Address'
            onChange={(n, value) => setEmail(value)}
            {
            ...(errorMessage ? { customErrorMessage: errorMessage } : {})
            }
            {...params}
          />}
        />
      </From>
    </main>
    <BaseModal
      size='small'
      show={openAccountLockoutSuccessModal}
      title={'Password Reset'}
      modalBodyClass={'text-center'}
      body={<>Steps on how to access your account will be emailed to you if your email address, <b>{email}</b>, is registered.</>}
      modalPrimaryButton={'Back to Sign In'}
      onClose={toggleModal}
    ></BaseModal>
  </>
  );
};

export default AccountLockout;
